import { render, staticRenderFns } from "./ReceptionFlow.vue?vue&type=template&id=3c7f4abb&scoped=true"
import script from "./ReceptionFlow.vue?vue&type=script&lang=js"
export * from "./ReceptionFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f4abb",
  null
  
)

export default component.exports